import ExcelResultTable from "./ExcelResultTable";
import CalculationWarning from "./CalculationWarning";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Paper,
  Typography,
  Backdrop,
  CircularProgress,
  Tabs,
  Tab,
  Skeleton,
} from "@mui/material";

const DishedHeadCalculation = ({ data, loading, error }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [activeView, setActiveView] = useState(0);
  const [detailLoading, setDetailLoading] = useState(false);

  const isTower = activeView === 1;


  useEffect(() => {
    setDetailLoading(true);
    const timer = setTimeout(() => setDetailLoading(false), 400);
    return () => clearTimeout(timer);
  }, [activeView]);

  const renderSkeleton = () => (
    <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
  );


  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <Tabs
        value={activeView}
        onChange={(_, v) => setActiveView(v)}
        textColor="primary"
        indicatorColor="primary"
        sx={{
          mb: 3,
          "& .MuiTabs-flexContainer": { justifyContent: "center", gap: 1 },
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 700,
            fontSize: "0.9rem",
            borderRadius: "8px 8px 0 0",
            color: "var(--text-secondary)",
            "&.Mui-selected": { color: "primary.main" },
          },
          "& .MuiTabs-indicator": { backgroundColor: "primary.main", height: 3 },
        }}
      >
        <Tab label={t("budgetForm.vesselCalc.tank")} />
        <Tab label={t("budgetForm.vesselCalc.tower")} />
      </Tabs>

      {error ? (
        <CalculationWarning error={error} />
      ) : data != null ? (
        <Box sx={{ width: "100%" }}>
          {detailLoading || loading ? renderSkeleton() : (
            <>
              <Box>
                <Paper sx={{ p: 2, minHeight: 400, height: "100%" }}>
                  <Typography variant="subtitle1" fontWeight={600} mb={2} textAlign="center" sx={{ color: "var(--text-primary)" }}>
                    {t("budgetForm.dishedHeadCalc.torisphericalHeadsTitle")} - [{isTower ? t("budgetForm.vesselCalc.tower") : t("budgetForm.vesselCalc.tank")}]
                  </Typography>
                  <ExcelResultTable tableType="DISHED_HEAD_1" isTower={isTower} data={data} />
                </Paper>
              </Box>

              <Box>
                <Paper sx={{ p: 2, minHeight: 400, marginTop: 4 }}>
                  <Typography variant="subtitle1" fontWeight={600} mb={2} textAlign="center" sx={{ color: "var(--text-primary)" }}>
                    {t("budgetForm.dishedHeadCalc.largestNozzleTitle")} - [{isTower ? t("budgetForm.vesselCalc.tower") : t("budgetForm.vesselCalc.tank")}]
                  </Typography>
                  <ExcelResultTable tableType="DISHED_HEAD_2" isTower={isTower} data={data} />
                </Paper>
              </Box>

              <Box>
                <Paper sx={{ p: 2, minHeight: 400, marginTop: 4 }}>
                  <Typography variant="subtitle1" fontWeight={600} mb={2} textAlign="center" sx={{ color: "var(--text-primary)" }}>
                    {t("budgetForm.dishedHeadCalc.openingCheckTitle")} - [{isTower ? t("budgetForm.vesselCalc.tower") : t("budgetForm.vesselCalc.tank")}]
                  </Typography>
                  <ExcelResultTable tableType="DISHED_HEAD_3" isTower={isTower} data={data} />
                </Paper>
              </Box>
            </>
          )}
        </Box>
      ) : (
        <CalculationWarning />
      )}

      <Backdrop
        open={loading}
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: isDarkMode ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.85)",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress sx={{ color: "primary.main" }} size={40} />
      </Backdrop>
    </Box>
  );
};

export default DishedHeadCalculation;
